import ServiceAssignmentRulesBaseController from '../common/service_assignment_rules.base.controller';

class ServiceAssignmentRulesCreateController extends ServiceAssignmentRulesBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, ServiceAssignmentRulesService, Modal, $translate, $stateParams)
        this.$q = $q;
        this.User = User; 
        this.hasACL = {};

        this.defaultModel = {
            
        };
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() { }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }

    submit() { }
}

export default ServiceAssignmentRulesCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/service_assignment_rules/create/service_assignment_rules.create.controller.js